import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/index.css";
import { AuthProvider } from "./contexts/auth-context.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    // <React.StrictMode>
    <AuthProvider>
        <App />
    </AuthProvider>
    // </React.StrictMode>
);

// TODO Next Version
/**
 * Requirement:
Online live stream ticket
Payment integration
Only one device can access the live stream at the moment

Process Flow:
Admin start a live stream in YouTube and set it as unlisted
Admin put the link to the Manage Event section
User can buy the ticket from the event page
User will be asked to key in the email as minimum required 
User will be then showed the pricing, instruction, and policy on the screen, click continue button
User will be redirect to payment gateway link to make the payment.
After user made the payment:
If success:
User will be redirect back to our website
Payment gateway call a callback url and our server will receive the order and send an email for the ticket
If error 
User will be redirect back to our website
When event start user can click the link to open the website or open our website key in the code
The system will display the stream with recording the user browser to make sure it only be seen at one time on one device.
TODO:
Page
Modify Manage Event Page to add a set youtube live stream url option and a toggle button to set whether this event is host on live stream. 
Modify Event Page to add a buy online ticket option

A new policy page
A page to show the Product, pricing, event details, instruction and ask them to fill up basic information
A redirect success page
A redirect fail page
A page for users to keyin the code to watch the livestream (disable user to open inspector in case someone who has little knowledge on it can cheat the link and share to others).
Manage event pages add a new tab to see a list of online sold ticket records.
		
Extra 
Customize reset password page (now using firebase ui)
Reset password email template (with our logo something, now also using firebase default one)
Fighter will receive an email once they register successful as a fighter
Tutorial page (a page with text and screen shot to teach user HOW-TO, like how to register, how to update info, how to buy ticket, how to join live stream)

Backend features 
success callback url
Record user info and generate a code
Send email with code
Failed callback url
A api to request for youtube link

 */
